export const Types = {
    GET_ASSEMBLYRESPONSIBLES: "GET_ASSEMBLYRESPONSIBLES",
    SET_ASSEMBLYRESPONSIBLES: "SET_ASSEMBLYRESPONSIBLES",

    GET_SERVICEORDER: "GET_SERVICEORDER",
    SET_SERVICEORDER: "SET_SERVICEORDER",
    SAVE_SERVICEORDER: "SAVE_SERVICEORDER",

    GET_SERVICEORDER_PLANNED: "GET_SERVICEORDER_PLANNED",
    SET_SERVICEORDER_PLANNED: "SET_SERVICEORDER_PLANNED",
    SAVE_SERVICEORDER_PLANNED: "SAVE_SERVICEORDER_PLANNED",
    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};

export const getAssemblyResponsibles = (payload) => ({
    type: Types.GET_ASSEMBLYRESPONSIBLES,
    payload: payload,
});

export const setAssemblyResponsibles = (payload) => ({
    type: Types.SET_ASSEMBLYRESPONSIBLES,
    payload: payload,
});

export const getServiceOrder = (payload) => ({
    type: Types.GET_SERVICEORDER,
    payload: payload,
});

export const setServiceOrder = (payload) => ({
    type: Types.SET_SERVICEORDER,
    payload: payload,
});

export const saveServiceOrder = (payload) => ({
    type: Types.SAVE_SERVICEORDER,
    payload: payload,
});

export const getServiceOrderPlanned = (payload) => ({
    type: Types.GET_SERVICEORDER_PLANNED,
    payload: payload,
});

export const setServiceOrderPlanned = (payload) => ({
    type: Types.SET_SERVICEORDER_PLANNED,
    payload: payload,
});

export const saveServiceOrderPlanned = (payload) => ({
    type: Types.SAVE_SERVICEORDER_PLANNED,
    payload: payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});
